import { render, staticRenderFns } from "./SiteMapSettings.vue?vue&type=template&id=ace768f2&scoped=true"
import script from "./SiteMapSettings.vue?vue&type=script&lang=js"
export * from "./SiteMapSettings.vue?vue&type=script&lang=js"
import style0 from "./SiteMapSettings.vue?vue&type=style&index=0&id=ace768f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ace768f2",
  null
  
)

export default component.exports